module.exports = __webpack_public_path__ + "media/next_game_start_1.808b8ef8.mp3";